import PropTypes from 'prop-types';
import React from 'react';
import { Handles, Rail, Slider, Ticks, Tracks } from 'react-compound-slider';

import { bind } from 'bind-decorator';

import { Handle, Rail as SliderRail, Tick, Track } from './slider-components'; // example render components - source below

import { createStyles, withStyles } from '@material-ui/core';

const style = () => {
  return createStyles({
    root: {
      height: 50,
      padding: 5
    },

    disabled: {
      pointerEvents: 'none'
    },

    slider: {
      position: 'relative',
      minWidth: 360,
      maxWidth: 600
    },

    '@media (max-width:375px)': {
      slider: {
        minWidth: 0
      }
    },

    '@media print': {
      root: {
        minWidth: '360px'
      },

      slider: {
        minWidth: '360px'
      }
    }
  });
};

class ClinicalSlider extends React.Component {
  @bind
  onChange(values) {
    const { field, readOnly } = this.props;

    if (readOnly) {
      return;
    }
    this.props.onChange(values[0], field);
  }
  render() {
    let {
      props: { classes, min, max, readOnly, increment, value, inline, allowNotApplicable }
    } = this;
    min = parseInt(min);
    max = parseInt(max);
    min = isNaN(min) ? 0 : min;
    max = isNaN(max) ? 0 : max;
    value = parseFloat(value);
    value = isNaN(value) ? 0 : value;
    let domain = [min, max];
    increment = parseFloat(increment);
    increment = isNaN(increment) ? 1 : increment;
    let tickCount = (max - min) / increment;
    // the following determines sensible tick counts for inline and large numbers
    if (inline && tickCount > 10) {
      tickCount = max > 999 ? 5 : 10;
    } else if (tickCount > 20) {
      tickCount = 20;
    }

    return (
      <div className={classes.root + ' ' + (readOnly ? classes.disabled : '')}>
        <Slider
          mode={2}
          step={increment}
          domain={domain}
          onChange={this.onChange}
          className={classes.slider}
          values={[value]}
        >
          <Rail>{({ getRailProps }) => <SliderRail getRailProps={getRailProps} />}</Rail>
          <Handles>
            {({ handles, getHandleProps }) => (
              <div>
                {handles.map((handle) => (
                  <Handle
                    key={handle.id}
                    handle={handle}
                    domain={domain}
                    getHandleProps={getHandleProps}
                    allowNotApplicable={allowNotApplicable}
                  />
                ))}
              </div>
            )}
          </Handles>

          <Tracks right={false}>
            {({ tracks, getTrackProps }) => (
              <div>
                {tracks.map(({ id, source, target }) => (
                  <Track key={id} source={source} target={target} getTrackProps={getTrackProps} />
                ))}
              </div>
            )}
          </Tracks>
          {tickCount > 0 ? (
            <Ticks count={tickCount}>
              {({ ticks }) => (
                <div className="slider-ticks">
                  {ticks.map((tick) => (
                    <Tick
                      key={tick.id}
                      tick={tick}
                      count={ticks.length}
                      allowNotApplicable={allowNotApplicable}
                    />
                  ))}
                </div>
              )}
            </Ticks>
          ) : (
            <span />
          )}
        </Slider>
      </div>
    );
  }
}

ClinicalSlider.defaultProps = {
  min: 0,
  max: 10,
  increment: 1
};

export default withStyles(style)(ClinicalSlider);
